// extracted by mini-css-extract-plugin
export default {"root":"styles-root-f0f2e6","content":"styles-content-e0ae48","loading":"styles-loading-db3440","loading-spinner-btn":"styles-loading-spinner-btn-dc971d"};